"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledListItem = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledListItem = styled_components_1.default.li `
  width: 100%;
`;
